export default {
	props: {
		status: {
			type: String,
			required: true,
			validator: (status) => {
				return [
					'hidden', 'hiding', 'showing', 'showed'
				].indexOf(status) !== -1;
			}
		},

		toggle: {
			type: Function,
			required: true
		},

		order: {
			type: Number
		},

		content_width: {
			type: String
		},

		disable_backdrop_click: {
			type: Boolean,
			default: true
		},
	},
};
